import { Component, OnInit, Input } from '@angular/core';
import { Reservation, ReservationsService } from '../../reservations.service';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-reservation-item',
    templateUrl: './reservation-item.component.html',
    styleUrls: ['./reservation-item.component.css'],
    standalone: false
})
export class ReservationItemComponent implements OnInit {

  @Input() reservation: Reservation = new Reservation();
  @Input() index: number;
  public icons: { [name: string]: any } = {
    'faCheck': faCheck,
  };

  constructor(private _reservationsService: ReservationsService) { }

  ngOnInit(): void {
  }

  onReservationApproveClick(index: number) {
    this._reservationsService.approveReservationSubject.next(index);
  }

}
